// extracted by mini-css-extract-plugin
module.exports =  {"checkbox":"coursesModal__checkbox"};